<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="title"
  >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Width:"
      >
        <b-form-input
          v-model="width"
          autocomplete="off"
          :disabled="inProgress"
        />
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        :disabled="inProgress"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: ['widgetKey', 'gridId'],
  data () {
    return {
      cellKey: null,
      width: null,
      inProgress: false
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    title () {
      if (!this.cellKey) return null

      return `Minimal width for "${this.dataGrid_options[this.gridId].meta[this.cellKey].displayName}" column`
    }
  },
  methods: {
    open () {
      if (this.$refs.modal) {
        this.$refs.modal.show()
      }
    },
    close () {
      if (this.$refs.modal) {
        this.$refs.modal.hide()
      }
    },
    save () {
      if (this.inProgress) return
      this.inProgress = true

      if (!this.width) this.width = null

      const data = {
        gridId: this.gridId,
        oName: `meta/${this.cellKey}/minWidth`,
        oValue: this.width
      }

      db.dataGrid.options.saveOption(data, () => {
        this.inProgress = false
        this.width = null
        this.close()
      })
    }
  },
  created () {
    eventBus.$on(`showColWidthModal${this.widgetKey}-${this.gridId}`, (cellKey) => {
      this.cellKey = cellKey
      const curWidth = this.dataGrid_options[this.gridId].meta[this.cellKey].minWidth
      
      this.width = curWidth ? curWidth : null

      this.open()
    })
  }
}
</script>
